import { colors, Margin } from '@spritz-finance/ui'
import React from 'react'
import styled from 'styled-components'

const StyledCard = styled.div<{ margin?: Margin }>`
    position: relative;
    padding: ${({ margin }) => margin ?? Margin.Small};
    border: 2px solid var(--background-primary, ${colors.white});
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    margin: 0;
    transition: height 0.2s ease-in-out;
    background: var(--background-primary, ${colors.white});
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.2);
`

export const CardDivider = styled.div`
    width: 100%;
    margin: ${Margin.Med} 0;
    border-bottom: 1.5px solid ${colors.white};
`

export const CardDividerSmall = styled.div`
    width: 100%;
    margin: ${Margin.Small} 0;
    border-bottom: 1px solid var(--surface-3, ${colors.ltGrey});
`

export const Card: React.FC<{ className?: string; margin?: Margin }> = ({
    children,
    className,
    margin,
}) => {
    return (
        <StyledCard className={className} margin={margin}>
            {children}
        </StyledCard>
    )
}
